export default "__VITE_ASSET__CnAIk$Io__"